import { Component, inject, Input, OnInit, Renderer2, RendererFactory2 } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, NavigationError, Router } from '@angular/router';
import { PATHS } from '../../../models/bary-paths.model';
import { Title } from '@angular/platform-browser';
import { LoginService } from '../../../services/login.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ICustomer } from '../../../models/customer.model';
import { LoginModalService } from '../../../services/login-modal.service';
import { Transporter } from '../../../models/transporter.model';
import { User } from '../../../models/user.model';
import { CurrentDataService } from '../../../services/current-data-service';

@Component({
  selector: 'jhi-navigation',
  templateUrl: './navigation.component.html',
})
export class NavigationComponent implements OnInit {
  private readonly currentDataService = inject(CurrentDataService);
  private readonly router = inject(Router);
  private readonly translateService = inject(TranslateService);
  private readonly loginModalService = inject(LoginModalService);
  private readonly titleService = inject(Title);
  private readonly loginService = inject(LoginService);
  private readonly rootRenderer = inject(RendererFactory2);

  @Input() inProduction = false;
  @Input() swaggerEnabled = false;
  @Input() isAuthenticated = false;

  protected readonly PATHS = PATHS;

  protected transporter!: Transporter;
  protected customer?: ICustomer;
  protected account?: User;

  private readonly renderer: Renderer2 = this.rootRenderer.createRenderer(document.querySelector('html'), null);

  public ngOnInit(): void {
    this.currentDataService.getCurrentTransporter().subscribe(currentTransporter => {
      this.transporter = currentTransporter!;
      this.updateTitle();
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateTitle();
      }
      if (event instanceof NavigationError && event.error.status === 404) {
        this.router.navigateByUrl(PATHS.NOT_FOUND.path);
      }
    });

    this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.updateTitle();

      this.renderer.setAttribute(document.querySelector('html'), 'lang', langChangeEvent.lang);
    });

    this.currentDataService.getAccount().subscribe(account => {
      if (account) {
        this.account = account;
      }
    });

    this.currentDataService.getCustomer().subscribe(value => {
      if (value) {
        this.customer = value;
      }
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationError && event.error.status === 404) {
        this.router.navigateByUrl(PATHS.NOT_FOUND.path).then();
      }
    });
  }

  public login(): void {
    this.loginModalService.open();
  }

  public logout(): void {
    this.loginService.logout();
    this.customer = undefined;
    this.account = undefined;
    this.currentDataService.handleLogout();
    this.router.navigateByUrl(PATHS.HOME.path).then();
  }

  private getPageTitle(routeSnapshot: ActivatedRouteSnapshot): string {
    let title: string = routeSnapshot?.data['pageTitle'] ?? '';
    if (routeSnapshot.firstChild) {
      title = this.getPageTitle(routeSnapshot.firstChild) || title;
    }
    return title;
  }

  private updateTitle(): void {
    if (!this.getPageTitle(this.router.routerState.snapshot.root)) {
      this.currentDataService.getCurrentTransporter().subscribe(currentTransporter => {
        if (currentTransporter?.shopName) {
          this.titleService.setTitle(currentTransporter.shopName);
        }
      });
    }
  }

  public goTo(url: string): void {
    this.router.navigateByUrl(url).then();
  }
}
